import { defineComponent as _defineComponent } from 'vue'
import { FacadeInterface } from "@/types/FacadeInterface";
  
  import { formatPriceTrim } from "@/helpers/transformation/price";

  type Props = {
    facade: FacadeInterface;
  };
  
export default /*@__PURE__*/_defineComponent({
  __name: 'FacadeItemCard',
  props: {
    facade: {}
  },
  emits: ["update", "delete"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const deleteFacade = () => {
    emits("delete", props.facade);
  };

  const updateFacade = () => {
    emits("update", props.facade);
  };

const __returned__ = { emits, props, deleteFacade, updateFacade, get FacadeInterface() { return FacadeInterface }, get formatPriceTrim() { return formatPriceTrim } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})